<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="项目名称:" prop="strDocumentTitle" clearable>
        <el-input v-model.trim="searchForm.strDocumentTitle" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="销售人员:" prop="strSaleName" clearable>
        <el-input v-model.trim="searchForm.strSaleName" placeholder="请输入销售人员姓名" />
      </el-form-item>
      <el-form-item label="最终客户:" prop="strCRMAccountName">
        <el-input v-model.trim="searchForm.strCRMAccountName" placeholder="请输入最终客户名称" />
      </el-form-item>
      <el-form-item label="订单时间:" prop="strStartTime">
        <div class="rj-flex" style="width:260px;">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.strStartTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.strEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <!--<el-form-item label="流程分类:">-->
      <!--<el-select placeholder="请选择" v-model="searchForm.orderType" clearable>-->
      <!--<el-option v-for="option in orderProcessType" :label="option.name" :value="option.code" :key="option.code" />-->
      <!--</el-select>-->
      <!--</el-form-item>-->
      <el-form-item>
        <el-button type="primary" :loading="isEcpLoading && isOpLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <div v-loading="isOpLoading" class="tableBody">
      <div class="table-title">
        新下单系统单据
      </div>
      <el-table :data="opTableData" border style="width: 100%">
        <el-table-column prop="date" label="操作" width="70" align="left" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" @click="goDoIt(row, 1)">
              办理
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="oppName" label="项目名称" align="left" />
        <el-table-column prop="flowClass" label="流程分类" align="left" width="130" />
        <el-table-column prop="integratorsPriceTotal" label="集成商总价(元)" align="right" header-align="left" width="160">
          <template v-slot="{row}">
            <span v-if="row.flowClass==='确认服务主体'">--</span>
            <span v-else>{{ row.integratorsPriceTotal }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="salesmanName" label="销售人员" align="left" width="90" />
        <el-table-column prop="crmAccountName" label="最终客户名称" align="left" />
        <el-table-column prop="stateDateTime" label="订单时间" align="left" width="150" />
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[5, 10, 20, 30, 40]"
          :page-size.sync="opPage.pageSize"
          :current-page.sync="opPage.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="opPage.total"
          hide-on-single-page
          @size-change="handerSizeChangeOp"
          @current-change="currentChangeOp"
        />
      </div>
    </div>

    <div v-loading="isEcpLoading" class="tableBody">
      <div class="table-title">
        原下单系统单据
      </div>
      <el-table :data="ecpTableData" border style="width: 100%">
        <el-table-column prop="date" label="操作" width="70" fixed="left" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="goDoIt(row, 0)">
              办理
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="oppName" label="项目名称" align="left" />
        <el-table-column prop="flowClass" label="流程分类" align="left" width="130" />
        <el-table-column prop="integratorsPriceTotal" label="集成商总价(元)" align="right" header-align="left" width="160">
          <template v-slot="{row}">
            <span v-if="row.flowClass==='确认服务主体'">--</span>
            <span v-else>{{ row.integratorsPriceTotal }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="salesmanName" label="销售人员" align="left" width="90" />
        <el-table-column prop="crmAccountName" label="最终客户名称" align="left" />
        <el-table-column prop="stateDateTime" label="订单时间" align="left" width="150" />
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[5, 10, 20, 30, 40]"
          :page-size.sync="ecpPage.pageSize"
          :current-page.sync="ecpPage.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="ecpPage.total"
          hide-on-single-page
          @size-change="handerSizeChangeEcp"
          @current-change="currentChangeEcp"
        />
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { mapState, mapActions } from 'vuex';
import { getApprovalOrderList } from '@/API/index';
import eventBus from '@/libs/eventBus';

export default {
  data () {
    return {
      searchForm: {
        strDocumentTitle: '',
        strSaleName: '',
        strStartTime: '',
        strEndTime: '',
        strCRMAccountName: ''
      },

      isEcpLoading: false,
      isOpLoading: false,
      ecpTableData: [],
      opTableData: [],
      ecpPage: {
        pageSize: 5,
        total: 0,
        currentPage: 1
      },
      opPage: {
        pageSize: 5,
        total: 0,
        currentPage: 1
      },

      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.strStartTime) {
            return time.getTime() <= (new Date(this.searchForm.strStartTime)).getTime();
          }
          return false;
        }
      },
      needLoadData: false
    };
  },

  computed: {
    ...mapState({
      orderProcessType: state => state.enumeration.orderProcessType
    })
  },

  mounted () {
    this.doSearch();
    eventBus.$on('CompleteChiefOrder', () => {
      this.needLoadData = true;
    });
  },

  activated () {
    if (this.needLoadData) {
      this.doSearch();
    }
  },

  destroyed () {
    eventBus.$off('CompleteChiefOrder');
  },

  methods: {
    ...mapActions(['getIsCurrentApprover']),

    queryOldEcpData () {
      let params = {
        ...this.searchForm,
        pageIndex: this.ecpPage.currentPage - 1,
        pageSize: this.ecpPage.pageSize,
        strAgentId: this.$store.state.user.userId,
        newEcpFlag: 0
      };
      this.isEcpLoading = true;

      getApprovalOrderList(params)
        .then((res) => {
          this.isEcpLoading = false;
          let { status, data } = res.data;
          if (status === '200') {
            this.ecpTableData = data.dt || [];
            this.ecpPage.total = data.totalCount;
          }
        }).catch(() => {
          this.isEcpLoading = false;
        });
    },

    queryOpData () {
      let params = {
        ...this.searchForm,
        pageIndex: this.opPage.currentPage - 1,
        pageSize: this.opPage.pageSize,
        strAgentId: this.$store.state.user.userId,
        newEcpFlag: 1
      };
      this.isOpLoading = true;

      getApprovalOrderList(params)
        .then((res) => {
          this.isOpLoading = false;
          let { status, data } = res.data;
          if (status === '200') {
            this.opTableData = data.dt || [];
            this.opPage.total = data.totalCount;
          }
        }).catch(() => {
          this.isOpLoading = false;
        });
    },

    doSearch () {
      this.queryOldEcpData();
      this.queryOpData();
    },

    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.strEndTime = '';
      this.page.currentPage = 1;
      this.doSearch();
    },

    // 改变每页条数 当前页回到第一页
    handerSizeChangeEcp (val) {
      this.ecpPage.currentPage = 1;
      this.queryOldEcpData();
    },

    // 改变当前页
    currentChangeEcp (val) {
      this.ecpPage.currentPage = val;
      this.queryOldEcpData();
    },

    // 改变每页条数 当前页回到第一页
    handerSizeChangeOp (val) {
      this.opPage.currentPage = 1;
      this.queryOpData();
    },

    // 改变当前页
    currentChangeOp (val) {
      this.opPage.currentPage = val;
      this.queryOpData();
    },

    async goDoIt (row, newEcpFlag) {
      let isApprover = await this.getIsCurrentApprover(row.documentID);
      if (isApprover) {
        if (row.flowClass !== '确认服务主体') {
          this.$router.push({
            name: 'ChiefOrderPriceDoIt',
            query: { newEcpFlag },
            params: { documentID: row.documentID }
          });
        } else {
          this.$router.push({
            name: 'ChiefOrderSubjectDoIt',
            query: { newEcpFlag },
            params: { documentID: row.documentID }
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.table-title{
  padding-bottom: 4px;
  color: #606266;
  font-size: 16px;
}
</style>
